import request from 'assets/js/http';

export function contributeList(data) {
  // 待创建贡献表列表
  return request({
    url: '/contribute/list',
    method: 'post',
    data
  });
}

export function oneClickCollection(data) {
  // 贡献表一键催收
  return request({
    url: '/contribute/oneClickCollection',
    method: 'post',
    data
  });
}

export function contributeCompanyList(data) {
  // 待创建贡献表列表
  return request({
    url: '/contribute/companyList',
    method: 'post',
    data
  });
}

export function contributeHide(data) {
  // 贡献表不再显示
  return request({
    url: '/contribute/hide',
    method: 'post',
    data
  });
}

export function contributeCreate(data) {
  // 创建评价表
  return request({
    url: '/contribute/create',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}
